import type { ViewController } from '@presentation/shell/NexxusShell';
import { dashboardController } from './dashboard';
import { salariesController } from './salaries';
import { saisieController } from './saisie';
import { bulletinsController } from './bulletins';
import { comptabiliteController } from './comptabilite';
import { entrepriseController } from './entreprise';
import { declarationsController } from './declarations';
import { utilisateursController } from './utilisateurs';
import { congesController } from './conges';
import { qualiteController } from './qualite';
import { rgpdController } from './rgpd';
import { confidentialiteController } from './confidentialite';
import { vieSocialeController } from './vieSociale';
import { conformiteController } from './conformite';
import { coffrefortController } from './coffrefort';
import { sanctionsController, evaluationsController, recrutementController } from './rhSimple';
import { attestationsController } from './attestations';
import { auditController } from './audit';
import { selfBulletinsController, selfCongesController, selfDocsController } from './self';
import { parametresController } from './parametres';
import { etatsController } from './etats';
import { ventesController, achatsController, tvaController, tiersController } from './facturation';
import { analytiqueController } from './analytique';
import { exercicesController, stocksController, immobilisationsController } from './erpSimple';
import { modulesController, nexxusInvoicesController } from './nexxusBilling';
import { cabinetController, portefeuilleController } from './cabinet';
import { pilotageController } from './pilotage';
import { flotteController } from './flotte';
import { fraisController } from './frais';
import { echeancesFiscalesController } from './echeancesFiscales';

/**
 * Registre des contrôleurs de données par écran (id de vue v2.2 sans le
 * préfixe `view-`). Les écrans non listés s'affichent avec leur markup v2.2
 * verbatim (structure conforme, données injectées ultérieurement).
 */
export const viewControllers: Record<string, ViewController> = {
  cabinet: cabinetController,
  portefeuille: portefeuilleController,
  dashboard: dashboardController,
  pilotage: pilotageController,
  salaries: salariesController,
  flotte: flotteController,
  frais: fraisController,
  'echeances-fiscales': echeancesFiscalesController,
  saisie: saisieController,
  bulletins: bulletinsController,
  comptabilite: comptabiliteController,
  entreprise: entrepriseController,
  declarations: declarationsController,
  utilisateurs: utilisateursController,
  // UI-5 — RH étendu & conformité
  conges: congesController,
  qualite: qualiteController,
  rgpd: rgpdController,
  confidentialite: confidentialiteController,
  'vie-sociale': vieSocialeController,
  conformite: conformiteController,
  coffrefort: coffrefortController,
  sanctions: sanctionsController,
  evaluations: evaluationsController,
  recrutement: recrutementController,
  attestations: attestationsController,
  // UI-6 — Self-service & administration
  audit: auditController,
  'self-bulletins': selfBulletinsController,
  'self-conges': selfCongesController,
  'self-docs': selfDocsController,
  parametres: parametresController,
  // UI-4 — Comptabilité / fiscalité / ERP
  etats: etatsController,
  ventes: ventesController,
  achats: achatsController,
  tva: tvaController,
  tiers: tiersController,
  analytique: analytiqueController,
  exercices: exercicesController,
  stocks: stocksController,
  immobilisations: immobilisationsController,
  modules: modulesController,
  'nexxus-factures': nexxusInvoicesController,
};
